<template>
    <div class="modal fade" id="modalNotification" tabindex="-1" role="dialog" aria-labelledby="modalNotification" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalNotification">{{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <label class="m-0" v-html="message"></label>
                    <div class="form-row mt-2">
                        <div class="form-group col-md-12">
                            <label class="m-0">{{ $t('str.msg.title.label') }}</label>
                            <input type="text" v-model="titleNotification" class="form-control" :placeholder="$t('str.msg.title.label')" />
                        </div>
                        <div class="form-group col-md-12">
                            <label class="m-0">{{ $t('str.msg.description.label') }}</label>
                            <textarea v-model="description" class="form-control" rows="3" :placeholder="$t('str.msg.description.label')"></textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary w-30" data-dismiss="modal" v-on:click="$emit('confirmation-return', {title: title, description: description})">{{yesText}}</button>
                    <button type="button" class="btn btn-secondary w-30" data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{cancelText}}</button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        components: {
        },
        props: ["title", "message", "cancelText", "yesText", "titleNotification", "description"],
        watch:{
            'titleNotification'(){
                this.titleNotification = this.titleNotification;
            },
            'description'(){
                this.description = this.description;
            }
        },
        data(){
            return {
            }
        },
        methods: {
        },
    }
</script>
